var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 68,
    viewBox: "0 0 62 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_959_1740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3634 51.0063C41.1204 51.0064 40.8798 51.0476 40.6553 51.1277C40.4308 51.2079 40.2269 51.3253 40.0552 51.4733C39.8835 51.6213 39.7474 51.7971 39.6546 51.9904C39.5618 52.1837 39.5143 52.3908 39.5146 52.6V57.6117C39.5147 58.0336 39.7096 58.4382 40.0563 58.7365C40.403 59.0348 40.8731 59.2025 41.3634 59.2025H56.1002C56.5904 59.2025 57.0606 59.0348 57.4073 58.7365C57.754 58.4382 57.9488 58.0336 57.949 57.6117V52.6C57.9493 52.3908 57.9017 52.1837 57.809 51.9904C57.7162 51.7971 57.5801 51.6213 57.4084 51.4733C57.2367 51.3253 57.0328 51.2079 56.8083 51.1277C56.5838 51.0476 56.3432 51.0064 56.1002 51.0063H41.3634ZM54.6604 53.9021C54.8449 53.8996 55.028 53.929 55.199 53.9885C55.37 54.048 55.5254 54.1364 55.6559 54.2485C55.7865 54.3606 55.8896 54.4942 55.9591 54.6412C56.0286 54.7882 56.0631 54.9457 56.0606 55.1044C56.0606 55.4192 55.9153 55.7211 55.6567 55.9437C55.3981 56.1662 55.0474 56.2913 54.6817 56.2913C54.316 56.2913 53.9652 56.1662 53.7066 55.9437C53.448 55.7211 53.3028 55.4192 53.3028 55.1044C53.2978 54.7901 53.438 54.487 53.6925 54.2615C53.9471 54.0361 54.2952 53.9068 54.6604 53.9021Z",
    fill: "url(#paint0_linear_959_1740)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.846 39.5256H34.3786C34.631 39.5248 34.8728 39.438 35.0509 39.2841C35.2291 39.1302 35.3291 38.9218 35.3291 38.7045C35.3291 38.4873 35.2291 38.2789 35.0509 38.125C34.8728 37.9711 34.631 37.8843 34.3786 37.8835H27.128C26.3634 37.8835 25.63 37.622 25.0894 37.1566C24.5487 36.6913 24.2449 36.0602 24.2449 35.4021C24.2449 34.744 24.5487 34.113 25.0894 33.6477C25.63 33.1824 26.3634 32.9209 27.128 32.9209H42.3335C44.5679 32.9209 46.7502 33.5015 48.5948 34.5867C50.4393 35.672 51.8602 37.2112 52.6714 39.003L56.7775 48.0725C56.8321 48.1931 56.8517 48.3233 56.8345 48.4519C56.8174 48.5805 56.7641 48.7036 56.6792 48.8105C56.5942 48.9173 56.4803 49.0048 56.3473 49.0652C56.2142 49.1256 56.0661 49.157 55.9156 49.157H40.1907C39.6241 48.4224 38.8625 47.8145 37.9689 47.3832C37.0753 46.952 36.0754 46.7099 35.0516 46.6769H20.6229C18.8497 46.6769 17.1355 46.1288 15.7925 45.1322L5.08159 37.1841C4.47719 36.7352 4.09572 36.1041 4.01571 35.4205C3.93571 34.737 4.16325 34.0529 4.6515 33.5094C5.13974 32.9658 5.85154 32.6041 6.64037 32.4985C7.4292 32.393 8.23502 32.5518 8.89196 32.9421L17.5894 38.1146C19.1344 39.0335 20.968 39.5257 22.846 39.5256Z",
    fill: "url(#paint1_linear_959_1740)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.301 6.19679C30.194 6.03551 31.1182 6.05469 32.0011 6.25276C32.884 6.45084 33.7015 6.82241 34.3894 7.33833C33.2715 7.77968 32.3088 8.46715 31.5984 9.33118L30.589 8.46251C30.3848 8.28684 30.1128 8.18167 29.8246 8.16685C30.277 9.03131 30.999 9.77095 31.9104 10.3036C32.8218 10.8362 33.8868 11.1409 34.9873 11.184C34.9855 11.4974 34.9499 11.8101 34.8811 12.1178C33.5886 12.0585 32.3401 11.694 31.2724 11.0643C30.2046 10.4347 29.359 9.56417 28.8282 8.54824C28.6474 8.7436 28.5564 8.98941 28.5728 9.23878C28.5891 9.48815 28.7115 9.72369 28.9167 9.90032L30.5371 11.2946C30.2881 12.1202 30.246 12.9822 30.4136 13.8229C30.5812 14.6637 30.9547 15.464 31.5093 16.171C30.3966 16.3355 29.2524 16.2218 28.2125 15.8434L27.5779 17.1052L26.1075 17.1357L26.0485 18.2108L24.7959 18.2413L24.7368 19.3193L23.4842 19.3497L23.4252 20.4277L22.1726 20.4582L22.1135 21.5362L20.8609 21.5666L20.8019 22.6445L19.2217 22.6853L18.8793 22.9799C18.7124 23.1235 18.5143 23.2375 18.2962 23.3152C18.0782 23.393 17.8444 23.433 17.6084 23.433C17.3724 23.433 17.1386 23.393 16.9206 23.3152C16.7025 23.2375 16.5044 23.1235 16.3375 22.9799L15.7767 22.4988C15.6098 22.3552 15.4774 22.1846 15.3871 21.9969C15.2968 21.8093 15.2503 21.6083 15.2503 21.4052C15.2503 21.202 15.2968 21.0009 15.3871 20.8132C15.4774 20.6256 15.6098 20.455 15.7767 20.3114L24.7297 12.6063C24.3196 11.4082 24.4371 10.122 25.0595 8.99366C25.682 7.86534 26.7659 6.97396 28.1039 6.49012C28.0301 5.58444 28.1935 4.67612 28.582 3.83201C28.9705 2.98791 29.5742 2.22965 30.3486 1.61312C31.123 0.99659 32.0483 0.537446 33.0564 0.269724C34.0644 0.00200284 35.1294 -0.0675729 36.1729 0.0661607C37.2163 0.199894 38.2115 0.533539 39.0852 1.04243C39.9588 1.55132 40.6886 2.22262 41.2207 3.00659C41.7527 3.79057 42.0735 4.66725 42.1594 5.57215C42.2452 6.47705 42.094 7.38703 41.7167 8.23491C41.4286 8.02345 41.1211 7.8325 40.7971 7.66391C41.0681 6.95337 41.1553 6.20034 41.0525 5.45773C40.9498 4.71513 40.6596 4.00094 40.2022 3.36504C39.7449 2.72914 39.1315 2.18691 38.4051 1.77653C37.6787 1.36615 36.8567 1.09743 35.9969 0.989252C35.1371 0.881077 34.2602 0.936092 33.4277 1.15034C32.5951 1.36458 31.8271 1.73292 31.1774 2.22955C30.5277 2.72618 30.0121 3.33913 29.6666 4.02534C29.3212 4.71156 29.1543 5.45449 29.1776 6.20207L29.301 6.19679Z",
    fill: "url(#paint2_linear_959_1740)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0637 29.7072H36.2739C36.0379 29.7072 35.8042 29.6672 35.5861 29.5895C35.368 29.5118 35.1699 29.398 35.0029 29.2543C34.836 29.1107 34.7036 28.9402 34.6133 28.7525C34.523 28.5648 34.4765 28.3637 34.4765 28.1606V17.2639C33.4188 16.7678 32.563 16.005 32.0238 15.078C31.4847 14.151 31.2882 13.1043 31.4606 12.0784C32.837 12.7211 34.4032 12.9998 35.9628 12.8798H39.4674C39.7795 12.8782 40.0781 12.7704 40.2981 12.5799C40.5181 12.3895 40.6416 12.1319 40.6416 11.8633C40.6416 11.5948 40.5181 11.3371 40.2981 11.1466C40.0781 10.9562 39.7795 10.8484 39.4674 10.8468H36.2326C34.9149 10.8137 33.6411 10.4314 32.5852 9.75221C33.1318 9.12701 33.839 8.61906 34.6514 8.26788C35.4638 7.9167 36.3596 7.73181 37.2687 7.72773C38.1778 7.72365 39.0758 7.90045 39.8924 8.24431C40.7091 8.58818 41.4223 9.08979 41.9766 9.71004C42.5308 10.3303 42.9109 11.0524 43.0874 11.8199C43.2638 12.5875 43.2318 13.3798 42.9937 14.135C42.7557 14.8901 42.3181 15.5876 41.7151 16.1732C41.1121 16.7588 40.3601 17.2166 39.5176 17.5107L40.1079 18.7892L39.0914 19.7039L39.9497 20.4856L39.0891 21.2693L39.9497 22.053L39.0891 22.8367L39.9497 23.6204L39.0891 24.4042L39.9497 25.1877L39.0891 25.9714L39.9497 26.7551L38.8636 27.744V28.1606C38.8636 28.3637 38.8171 28.5648 38.7267 28.7525C38.6364 28.9402 38.504 29.1107 38.3371 29.2543C38.1702 29.398 37.972 29.512 37.7539 29.5897C37.5359 29.6674 37.3021 29.7074 37.0661 29.7074L37.0637 29.7072Z",
    fill: "url(#paint3_linear_959_1740)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_959_1740",
    x: 0,
    y: 0,
    width: 61.949,
    height: 67.2025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.878281 0 0 0 0 0.878281 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_1740",
    x1: 50.5,
    y1: 85.5,
    x2: 81.733,
    y2: 54.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247023,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501463,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690614,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916086,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_959_1740",
    x1: 75,
    y1: 55,
    x2: 68.0591,
    y2: 5.61534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.150537,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353575,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542364,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74096,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_959_1740",
    x1: 28.0293,
    y1: 25.8279,
    x2: 28.4041,
    y2: -0.00197884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197633,
    stopColor: "#073B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#1C648E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#2587B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#289FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_959_1740",
    x1: 36.5456,
    y1: 30.5578,
    x2: 36.5456,
    y2: 7.92292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaseIcon);
export default __webpack_public_path__ + "static/media/LeaseIcon.e558e70d2380c803a84969d4baf3f042.svg";
export { ForwardRef as ReactComponent };